































import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import CommentDialog from "@/components/dialogs/CommentDialog.vue";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { DocumentAnchor, DocumentTypePrimitive } from "@infoland/iprova-api";
import { CommentType } from "@/enums";
import storeHelper from "@/store/store-helper";
export default Vue.extend({
    name: "AddCommentAction",
    components: { DocumentToolbarAction, ZenyaDialog, CommentDialog },
    props: {
        documentProperties: Object as () => DocumentVersionInfo,
        commentSubjectSelections: Array as () => DocumentAnchor[],
        commenterTypeForAddingComment: String as () => CommentType,
        showCommentsList: Boolean,
        userIsDocumentAdministrator: Boolean,
        enable: { default: true },
        isButton: Boolean
    },
    data: function () {
        return {
            commentDialogVisible: false
        };
    },
    watch: {
        commentDialogVisible: function () {
            storeHelper.siteStore.setIsDialogDisplayed(this.commentDialogVisible);
        }
    },
    computed: {
        isInteractiveDocument(): boolean {
            if (this.documentProperties) return this.documentProperties.type == DocumentTypePrimitive.interactive;
            return false;
        },
        isStructuredDocument(): boolean {
            if (this.documentProperties) return this.documentProperties.type == DocumentTypePrimitive.structured_document;
            return false;
        }
    },
    methods: {
        setCommentDialogVisible(): void {
            this.commentDialogVisible = true;
        }
    }
});
